import endOfLastSchoolYear from "@/utils/endOfLastSchoolYear";
import startOfLastSchoolYear from "@/utils/startOfLastSchoolYear";

/**
 * Calculate the current school year start and end date based on the current date.
 * @param {Date} date - Date to be used to calculate the school year. It defaults to today.
 * @example
 * // returns {startDate: new Date('07/01/2020'), endDate: new Date('06/30/2021')} if today is new Date('11/01/2021')
 * getLastSchoolYear();
 * * // returns {startDate: new Date('07/01/2020'), endDate: new Date('06/30/2021')} if today is new Date('03/21/2022')
 * getLastSchoolYear();
 * @returns { startDate: Date, endDate: Date} Returns an object with the startDate and endDate properties.
 */
const getLastSchoolYear = (date = new Date()) => ({
  startDate: startOfLastSchoolYear(date),
  endDate: endOfLastSchoolYear(date),
});

export default getLastSchoolYear;
